'use client';
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";


const renderImage = (_path: any, immg: any, data: any, setImgZoom: any, _width: any, _height: any, _imgzoom: any, className: any, props: any) => {
  const useBlur =
    _width >= 40 &&
    _height >= 40 &&
    !className?.includes('main-img');

  return (<Image
    src={_path}
    alt={immg?.alternative ?? ''}
    title={immg?.title ?? ''}
    onClick={(e: any) => {
      if (data?.image_zoom) setImgZoom(true)
    }}
    width={data?.imagewidth || _width}
    height={data?.imageheight || _height}
    className={`${data?.imageborder ? 'border mw-100 custom_image' : ''} ${_imgzoom ? 'mw-10' : 'mw-100 custom_image'}  ${className ? className : ''} ${data?.image_zoom ? "cursor-pointer" : ""} `}
    sizes="(max-width: 768px) 100vw, 50vw"
    placeholder={useBlur ? 'blur' : undefined}
    blurDataURL={useBlur ? process.env.NEXT_PUBLIC_DATA_BLUR_URL : undefined}
    {...props}
  />);
}

export default function Nimage({ immg, data, className, ...props }: any) {
  const _path = immg.url;
  const _width = immg?.width;
  const _height = immg?.height;
  const [_imgzoom, setImgZoom] = useState<any>(false);
  return (
    <>
      {immg?.link != '' && immg?.link != null && immg?.link != undefined ?
        <Link
          href={immg?.link ? immg?.link : '/'}
          title={immg?.title != '' ? immg?.title : immg?.name}
        >
          {renderImage(_path, immg, data, setImgZoom, _width, _height, _imgzoom, className, props)}
          {immg?.description ?
            <p className="caption">{immg?.description}</p>
            : null}
        </Link>
        : <>
          {renderImage(_path, immg, data, setImgZoom, _width, _height, _imgzoom, className, props)}
          {immg?.description ?
            <p className="caption">{immg?.description}</p>
            : null}
        </>
      }
      {_imgzoom ?
        <div className="modal fade show d-block" aria-hidden="false">
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel"> {immg?.title ?? ''}</h5>
                <button onClick={(e: any) => { setImgZoom(false); }} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body text-center">
                {renderImage(_path, immg, data, setImgZoom, _width, _height, _imgzoom, className, props)}
              </div>
              <div className="modal-footer">
                <button type="button" onClick={(e: any) => { setImgZoom(false); }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        : null}
    </>
  )
}